var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentDomain.logo)?_c('div',{class:_vm.$style.logo,style:({ backgroundImage: ("url(" + (_vm.currentDomain.logo) + ")") })}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }